import initCarousel from '../helpers/carousel';

const selectors = {
  mainCarousel: '[flickity-slider-carousel]',
  prevBtn: '[data-carousel-prev-btn]',
  nextBtn: '[data-carousel-next-btn]',
};

export default class DynamicCollectionSelector {
  constructor(section) {
    // Init product items
    this.section = section;
    initCarousel(section.el, selectors);
  }
}
